<template>
  <div class="dashboard-card-piccola">

    <div class="titolo col-24 no-padding">
      {{ properties.title.toUpperCase() }}
    </div>
    <div class="valore col-24 no-padding">
      {{ properties.value }}
    </div>

  </div>
</template>

<script>
  export default {
    name: 'DashboardCardPiccola',
    props: {
      properties: {
        type: Object,
        required: true,
        default: function () {
          return {
            title: '',
            value: ''
          }
        }
      }
    },
    data () {
      return {}
    },
    methods: {}
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .dashboard-card-piccola {
    height: 80px;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    margin-top: 5px;
    padding: 0 10px !important;
    .titolo {
      height: 35px;
      line-height: 35px;
      .set-font(@family: 'os-semibold', @size: 14px, @color: @greenRiva);
      letter-spacing: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .valore {
      height: 40px;
      line-height: 40px;
      .set-font(@size: 16px, @color: #666);
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media screen and (max-width: 1400px) and (min-width: 1250px) {
    .dashboard-card-piccola  {
      padding: 0px 4px !important;
      .titolo {
        .set-font(@family: 'os-semibold', @size: 13px, @color: @greenRiva);
      }
      .valore {
        .set-font(@size: 13px, @color: #666);
        text-align: right;
      }
    }
  }

  @media screen and (max-width: 991px) and (min-width: 768px) {
    .dashboard-card-piccola  {
      padding: 0px 5px !important;
      .titolo {
        .set-font(@family: 'os-semibold', @size: 16px, @color: @greenRiva);
      }
      .valore {
        .set-font(@size: 15px, @color: #666);
        text-align: right;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponents/CardPiccola.vue